import { Injectable } from '@angular/core';
import { UserService } from '../services/User.service';
import { Observable } from 'rxjs/Observable';
import { GroupService } from '../services/Group.service';

@Injectable()
export class SharedUserService {
  private allUsers: any = [];
  private allUserGroups: any = [];
  private allCustomerGroups: any = [];
  async checkNeedRefresh() {
    const user = JSON.parse(localStorage.getItem('User')) || {};
    const settingTenantId = localStorage.getItem('UserSettingTenantId');
    if (settingTenantId !== user.tenant_id) {
      this.allUsers = [];
      this.allUserGroups = [];
      this.allCustomerGroups = [];
      localStorage.setItem('UserSettingTenantId', user.tenant_id);
    }
  }
  constructor(
    private userService: UserService,
    private groupService: GroupService
  ) {}

  async setAllUsers() {
    const data = await this.userService.all({}).toPromise();
    if (data.data && !data.error) {
      this.allUsers = data.data.list || [];
    }
  }
  async setUserGroups() {
    const data = await this.groupService.allGroup({ target: 'user' }).toPromise();
    if (data.data && !data.error) {
      this.allUserGroups = data.data || [];
    }
  }
  async setCustomerGroups() {
    const data = await this.groupService.allGroup({ target: 'end_user' }).toPromise();
    if (data.data && !data.error) {
      this.allCustomerGroups = data.data || [];
    }
  }
  async getAllUsers() {
    await this.checkNeedRefresh();
    if (!this.allUsers.length) {
      await this.setAllUsers();
    }
    return this.allUsers;
  }
  async getUserGroups() {
    await this.checkNeedRefresh();
    if (!this.allUserGroups.length) {
      await this.setUserGroups();
    }
    return this.allUserGroups;
  }
  async getCustomerGroups() {
    await this.checkNeedRefresh();
    if (!this.allCustomerGroups.length) {
      await this.setCustomerGroups();
    }
    return this.allCustomerGroups;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/share-data/user.service.ts